import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useFetch } from "./hooks/useFetch";
import { useAtom } from "jotai";
import { userAtom } from "./store/store";
import { API_USER_INFO } from "./constants/api";
import { useAfterLogin } from "./hooks/useAfterLogin";
import ToastProvider from "./components/common/Toast/ToastProvider";
import ToastService from "./components/common/Toast/ToastService";
import Home from "./pages/Home/Home";
import Records from "./pages/Records/Records";
import "./App.css";

function App() {
  const [user, setUser] = useAtom(userAtom);
  const { request } = useFetch();
  const { afterLogin } = useAfterLogin();

  const getUserInfo = async () => {
    const hasToken = !!localStorage.getItem("token");
    if (!hasToken) return Promise.reject(new Error("not login"));

    try {
      const {
        data: { email },
      } = await request<{ email: string }>(API_USER_INFO, {
        method: "GET",
      });
      const nickname = email.slice(0, 3).toUpperCase();
      setUser({ ...user, email, isLogin: true, nickname });
    } catch (error) {
      const msg = error instanceof Error ? error.message : (error as string);
      ToastService.error(msg);

      return Promise.reject(new Error("get user info error"));
    }
  };

  useEffect(() => {
    getUserInfo()
      .then(afterLogin)
      .catch((error) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <ToastProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/records" element={<Records />} />
          </Routes>
        </Router>
      </ToastProvider>
    </div>
  );
}

export default App;
